import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { PolicyGQL} from 'src/generated/graphql';
import { completeData } from '@app/_helpers/apollo';

@Component({
    selector: 'app-policy',
    templateUrl: './policy.component.html',
    styleUrls: ['./policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PolicyComponent implements OnInit {

  policy$: Observable<any> = of();
  constructor(private policyGql: PolicyGQL) { }

  ngOnInit(): void {
    this.policy$ = this.policyGql.watch().valueChanges.pipe(
      completeData(),
      map(response => {
        return (response.data.policy)
      })
    )
  }

}